import { Line3, Vector3 } from 'three';

/**
 * Returns an array of lines that are offset from the input points by the input directions.
 */
export const computeDirectedLines = (points: Vector3[], dirs: Vector3[], length: number = 1) => {
  return points.reduce((acc, point, i) => {
    const dir = dirs[i] ?? new Vector3();
    const offsetPoint = point.clone().add(dir).multiplyScalar(length);
    return [...acc, new Line3(point, offsetPoint)];
  }, [] as Line3[]);
};
